"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldCustomizeName = exports.templateTags = void 0;
exports.templateTags = ['{$', '}'];
const shouldCustomizeName = (name) => {
    if (!name)
        return false;
    return (name === null || name === void 0 ? void 0 : name.includes(exports.templateTags[0])) && (name === null || name === void 0 ? void 0 : name.includes(exports.templateTags[1]));
};
exports.shouldCustomizeName = shouldCustomizeName;
//# sourceMappingURL=shouldCustomizeName.js.map